// extracted by mini-css-extract-plugin
export default {"personalData":"personalData_personalData__XYrx2","form":"personalData_form__U5JYs","input":"personalData_input__6JXzi"};